import base from './base';
import { permissionComputeds } from './base';


export default {
	mixins: [base],
	computed: permissionComputeds('VIEW_USER', 'ADD_USER', 'CHANGE_USER', 'CHANGE_USER_ROLES', 'TRASH_USER', 'DELETE_USER'),
};
